/**
 * Generated by orval v8.5.3 🍺
 * Do not edit manually.
 * Space Invoices API
 * REST API for invoice management, customer management, and accounting operations. Features include cursor-based pagination for efficient data navigation, flexible JSON querying with MongoDB-style operators, full-text search across multiple fields, and comprehensive metadata support for custom tracking.
 * OpenAPI spec version: 1.0.0
 */

/**
 * Resolved calculation mode used for the preview after applying the request override or entity default.
 */
export type DocumentCalculationCalculationMode = typeof DocumentCalculationCalculationMode[keyof typeof DocumentCalculationCalculationMode];


export const DocumentCalculationCalculationMode = {
  b2b_standard: 'b2b_standard',
  b2c_gross_discount: 'b2c_gross_discount',
} as const;
